export default "__VITE_ASSET__e5ba152a__"